const parseUrl = (url, field) => {
    try {
        return new URL(url);
    }
    catch {
        throw new Error(`${field} must be a valid HTTPS URI`);
    }
};
export const validateHTTPSUrl = (url, field) => {
    const parsed = parseUrl(url, field);
    if (parsed.protocol !== 'https:')
        throw new Error(`${field} must be a valid HTTPS URI`);
};
export const validateScopes = (scopes) => {
    if (!Array.isArray(scopes))
        throw new Error('Scopes must be an array');
    if (scopes.length === 0 || !scopes.find(scope => scope === 'openid'))
        throw new Error('Scopes must contain "openid"');
};
